import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from './_virtual/_rollupPluginBabelHelpers.js'; // xhr that returns objects that look like fetch results, but still allows using events like progress

var buildResult = function buildResult(xhr) {
  return {
    status: xhr.status,
    statusText: xhr.statusText,
    json: function () {
      var _json = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", JSON.parse(xhr.response));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function json() {
        return _json.apply(this, arguments);
      }

      return json;
    }()
  };
};

function fetchXhr(url, options) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open(options.method, url);

    if (options.headers) {
      Object.entries(options.headers).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return xhr.setRequestHeader(key, value);
      });
    }

    if (options.credentials) {
      xhr.withCredentials = true;
    }

    if (options.events) {
      Object.entries(options.events).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        xhr[key] = value;
      });
    }

    xhr.onload = function () {
      if (options && options.events && options.events.onload && typeof options.events.onload === 'function') {
        options.events.onload();
      }

      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(buildResult(xhr));
      } else {
        reject({
          response: buildResult(xhr)
        });
      }
    };

    xhr.onerror = function () {
      if (options && options.events && options.events.onerror && typeof options.events.onerror === 'function') {
        options.events.onerror();
      }

      reject({
        response: buildResult(xhr)
      });
    };

    xhr.send(options.body);
  });
}

export { fetchXhr };